import { call, put, takeEvery, all } from 'redux-saga/effects';
import { REHYDRATE } from 'redux-persist';
import AuthApi from '../../api/AuthApi';
import * as Actions from '../actions/usersActions';
import * as Types from '../actions/usersActionTypes';
import * as StatusActions from '../actions/statusActions';

function* login(action) {
  const { email, password, staySignedIn, onFail } = action;
  try {
    const response = yield call(AuthApi.login, email, password, staySignedIn);
    sessionStorage.setItem('jwt', response.token);
    if (staySignedIn) localStorage.setItem('jwt', response.token);
    yield put(Actions.loginSuccess(response));
    yield put(Actions.getUser());
    yield put(Actions.getUsers());
  } catch (error) {
    console.info(error);
    yield put(Actions.loginFailure(error));
    yield call(onFail, error);
  }
}

function* refreshToken({ password, onSuccess, onFail }) {
  try {
    const response = yield call(AuthApi.refreshToken, password);
    sessionStorage.setItem('jwt', response.token);
    yield put(Actions.refreshTokenSuccess());
    yield call(onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.refreshTokenFailure(error));
    yield call(onFail, error);
  }
}

function* logout() {
  yield sessionStorage.removeItem('jwt');
  yield localStorage.removeItem('jwt');
}

function* register(action) {
  const { user, onSuccess, onFail } = action;
  try {
    const response = yield call(AuthApi.register, user);
    console.info(response);
    yield put(Actions.registerSuccess(response));
    yield call(onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.registerFailure(error));
    yield call(onFail, error);
  }
}

function* getJoinData({ token, onSuccess, onFail }) {
  try {
    const response = yield call(AuthApi.getJoinData, token);
    console.info(response);
    yield put(Actions.getJoinDataSuccess(response));
    yield call(onSuccess, response);
  } catch (error) {
    console.info(error);
    yield put(Actions.getJoinDataFailure(error));
    yield call(onFail);
  }
}

function* getWelcomeData({ token, onSuccess, onFail }) {
  try {
    const response = yield call(AuthApi.getWelcomeData, token);
    console.info(response);
    yield put(Actions.getWelcomeDataSuccess(response));
    yield call(onSuccess, response);
  } catch (error) {
    console.info(error);
    yield put(Actions.getWelcomeDataFailure(error));
    yield call(onFail);
  }
}

function* checkForOldToken({ payload }) {
  if (payload && payload.status && payload.status.tokenExpired) {
    try {
      yield put(StatusActions.tokenRefreshed());
      yield logout();
    } catch (error) {
      console.info(error);
    }
  }
}

export default function* authFlow() {
  yield all([
    takeEvery(Types.LOGIN, login),
    takeEvery(Types.LOGOUT, logout),
    takeEvery(Types.REGISTER, register),
    takeEvery(Types.GET_JOIN_DATA, getJoinData),
    takeEvery(Types.GET_WELCOME_DATA, getWelcomeData),
    takeEvery(Types.REFRESH_TOKEN, refreshToken),
    takeEvery(REHYDRATE, checkForOldToken),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/authFlow.js